import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../../../gql/fragments'

const DOC = gql`
  ${fragments.responsiblePerson.DOC}
  query ResponsiblePersons(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                responsiblePersons(spaceRecordId: $spaceRecordId) {
                  ...FragmentResponsiblePerson
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.ResponsiblePersonsQuery,
    ents.extra.space.Record.ResponsiblePerson[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'responsiblePersons',
                graphql.transformers.OUT.list(
                  fragments.responsiblePerson.TRANSFORMER,
                  { onNullish: 'remove' },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.ResponsiblePersonsQuery,
  ents.extra.space.Record.ResponsiblePerson[],
  graphql.schema.ResponsiblePersonsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
